import { formatDate } from "../formating"
import { getAdjustedDate, getFormattedDate } from "../helperFunctions"

const months = [
	"January",
	"February",
	"March",
	"April",
	"May",
	"June",
	"July",
	"August",
	"September",
	"October",
	"November",
	"December"
]

const currentDate = getAdjustedDate({ date: new Date() })
const currentYear = currentDate.getFullYear()
const defaultMaxDate = getAdjustedDate({ date: new Date(currentYear, 11, 31) })

export default function getEndDates({ minDate, maxDate, monthYearOnly }) {
	const endDates = []

	if (!minDate) return endDates
	minDate = getAdjustedDate({ date: minDate })

	const minMonth = minDate.getMonth()
	const minYear = minDate.getFullYear()

	maxDate = getAdjustedDate({ date: maxDate || defaultMaxDate })
	const maxMonth = maxDate.getMonth() + 1
	const maxYear = maxDate.getFullYear()

	const years = []
	for (let year = minYear; year <= maxYear; year++) years.push(year)

	for (const year of years) {
		let includedMonths = structuredClone(months)

		if (year === minYear) includedMonths = includedMonths.slice(minMonth)
		else if (year === maxYear) includedMonths = includedMonths.slice(0, maxMonth)

		for (const month of includedMonths) {
			let dateOptions = { dateStyle: "long" }
			if (monthYearOnly) dateOptions = { month: "long", year: "numeric" }

			const value = getAdjustedDate({ date: new Date(year, months.indexOf(month) + 1, 0) })
			const display = getFormattedDate({ date: value, options: dateOptions })
			const dateString = formatDate({ data: value, actions: ["mysql"] })

			endDates.push({ value, display, dateString })
		}
	}

	return endDates
}
